<template>
    <modal name="first-login" :classes="['v--modal', 'error-modal', 'first-login', hasBugs && 'has-bugs']"
        @before-open="beforeOpen" @before-close="beforeClose" :width="458" :height="'auto'" :scrollable="true"
        :adaptive="true">
        <div class="modal-title">{{ $t("firstLogin.completeRegistration") }}</div>
        <div class="modal-body">
            <div class="first-login-image"></div>
            <div class="form-group">
                <label for="first_name" class="label">{{ $t("firstLogin.yourName") }} :</label>
                <input type="text" id="first_name" v-model="localUser.first_name" @input="updated($event)"
                    @change="updated($event)" name="first_name" v-validate="'required|isAdult'" class="input"
                    :class="{ 'field-error': errors.has('first_name') }">
                <div class="v-error label-tip">{{ errors.first('first_name') }}</div>
            </div>
            <div class="form-group">
                <label for="last_name" class="label">{{ $t("firstLogin.yourLastName") }} :</label>
                <input type="text" id="last_name" v-model="localUser.last_name" @input="updated($event)"
                    @change="updated($event)" name="last_name" v-validate="'required'" class="input"
                    :class="{ 'field-error': errors.has('last_name') }">
                <div class="v-error label-tip">{{ errors.first('last_name') }}</div>
            </div>
            <div class="form-group multiselect-group">
                <label for="gender" class="label">{{ $t("firstLogin.gender") }} :</label>
                <multiselect v-model="localUser.gender" :options="genderOptions" :searchable="false"
                    :placeholder="$t('firstLogin.selectGender')" :custom-label="opt => customGenderLabel(opt)"
                    selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                    id="gender" name="gender" v-validate="{ genderVal: genderOptions }" class="multiselect-gender"
                    :class="{ 'multiselect-error': errors.has('gender') }"></multiselect>
                <div class="v-error label-tip">{{ errors.first('gender') }}</div>
            </div>
            <div class="form-group multiselect-group">
                <label for="birthday" class="label">{{ $t("firstLogin.dateBirth") }} :</label>
                <div class="birthday-wrapper">
                    <multiselect v-model="day" :options="dayOptions" :searchable="false" :placeholder="$t('firstLogin.day')"
                        selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                        :maxHeight="150" id="day" name="day" v-validate="'required|isAdult'" class="multiselect-day"
                        :class="{ 'multiselect-error': errors.has('day') }"></multiselect>
                    <multiselect v-model="month" :options="monthOptions" :custom-label="opt => customMonthLabel(opt)"
                        :searchable="false" :placeholder="$t('firstLogin.month')" selectLabel="" deselectLabel=""
                        :option-height="26" :allowEmpty="false" openDirection="bottom" :maxHeight="150" id="month"
                        name="month" v-validate="'required|isAdult'" class="multiselect-month"
                        :class="{ 'multiselect-error': errors.has('month') }"></multiselect>
                    <multiselect v-model="year" :options="yearOptions" :searchable="false"
                        :placeholder="$t('firstLogin.year')" selectLabel="" deselectLabel="" :option-height="26"
                        :allowEmpty="false" openDirection="bottom" :maxHeight="150" id="year" name="year"
                        v-validate="'required|isAdult'" class="multiselect-year"
                        :class="{ 'multiselect-error': errors.has('year') }"></multiselect>
                </div>
                <div v-if="errors.has('day') ||
                    errors.has('month') ||
                    errors.has('year')
                    " class="v-error label-tip">{{ errors.first('day') }}</div>
            </div>
            <div class="form-bottom-1">
                <button @click="next" v-if="!loader" class="button">{{ $t("firstLogin.next") }}</button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { consts } from '@/consts';
import { localizeValidation } from '@/mixins/localizeValidation';
import { updateForm } from '@/mixins/updateForm';
import { saveProfile } from '@/mixins/saveProfile';
import Multiselect from '@/components/Blocks/Multiselect';
import { checkScroll } from '@/mixins/checkScroll';

export default {
    name: 'FirstLogin',
    components: { Multiselect },
    props: {
        i18n: Object,
    },
    mixins: [
        localizeValidation,
        updateForm,
        saveProfile,
        checkScroll
    ],
    data() {
        return {
            hasBugs: false,
            loader: false,
            tempUser: {},
            consts: consts,
            first_name: '',
            last_name: '',
            gender: '',
            birthday: '',
            day: '',
            month: '',
            year: '',
            genderOptions: [1, 2],
            dayOptions: [],
            monthOptions: [],
            yearOptions: [],
            dataMonth: [
                { value: 1, text: this.$t('months.january') },
                { value: 2, text: this.$t('months.february') },
                { value: 3, text: this.$t('months.march') },
                { value: 4, text: this.$t('months.april') },
                { value: 5, text: this.$t('months.may') },
                { value: 6, text: this.$t('months.june') },
                { value: 7, text: this.$t('months.july') },
                { value: 8, text: this.$t('months.august') },
                { value: 9, text: this.$t('months.september') },
                { value: 10, text: this.$t('months.october') },
                { value: 11, text: this.$t('months.november') },
                { value: 12, text: this.$t('months.december') },
            ],
            gender: [
                { 'value': 1, 'text': this.$t('firstLogin.genderMan') },
                { 'value': 2, 'text': this.$t('firstLogin.genderWoman') }
            ],
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            userErrors: 'user/errors',
            isEmpty: 'user/isEmpty'
        }),
        localUser: function () {
            if (Object.keys(this.tempUser).length) {
                return this.tempUser;
            }
            this.tempUser = Object.assign({}, this.user);
            return this.tempUser;
        }
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
            this.tempUser = {};
            this.localizeValidation();

            const genderValRule = {
                getMessage(field, arr, data) {
                    return (data && data.message) || this.$t('firstLogin.required');
                },
                validate(value, arr) {
                    if (arr.indexOf(value) != -1) {
                        return { valid: true };
                    } else {
                        return { valid: false };
                    }
                }
            };

            this.$validator.extend('genderVal', genderValRule);

            let self = this;
            let isAdultMessage = this.$t('firstLogin.personsOverYears');
            const isAdultRule = {
                getMessage(field, data) {
                    return (data && data.message) || isAdultMessage;
                },
                validate(value) {
                    let isValid = () => {
                        let bDate = new Date();
                        bDate.setDate(self.day);
                        bDate.setMonth(self.month);
                        bDate.setFullYear(self.year);
                        bDate = bDate.getTime();
                        let years = new Date(+new Date() - bDate).getFullYear() - 1970;
                        return years >= 18;
                    }
                    if (!isValid()) {
                        self.$validator.errors.add({
                            field: 'day',
                            msg: isAdultMessage
                        });
                        self.$validator.errors.add({
                            field: 'month',
                            msg: isAdultMessage
                        });
                        self.$validator.errors.add({
                            field: 'year',
                            msg: isAdultMessage
                        });
                    } else {
                        self.$validator.errors.remove('day');
                        self.$validator.errors.remove('month');
                        self.$validator.errors.remove('year');
                    }
                    return { valid: isValid() }
                }

            }

            this.$validator.extend(
                'isAdult',
                isAdultRule
            );

            for (let i = 1; i <= 31; i++) {
                this.dayOptions.push(i);
                if (i <= 12) {
                    this.monthOptions.push(i);
                }
            }

            let today = new Date();

            for (let j = today.getFullYear(); j >= 1900; j--) {
                this.yearOptions.push(j);
            }

        },
        beforeClose(event) {
            if (
                !this.isEmpty('user') &&
                (
                    !this.tempUser.first_name ||
                    !this.tempUser.last_name ||
                    (this.tempUser.gender != 1 && this.tempUser.gender != 2) ||
                    !this.tempUser.birthday
                )
            ) {
                this.hasBugs = true;
                event.stop();
                document.body.classList.add('v--modal-block-scroll')
            } else {
                this.checkRemoveScroll();
            }
        },
        customGenderLabel(opt) {
            let text = '';
            let arr = this.gender.map(
                function (e) {
                    if (e.value == opt) {
                        text = e.text;
                    }
                }
            )
            return text;
        },
        customMonthLabel(opt) {
            return this.dataMonth[opt - 1].text;
        },
        next() {
            this.loader = true;
            this.$validator.validateAll()
                .then((valid) => {
                    this.loader = false;
                    if (valid) {
                        this.hasBugs = false;
                        this.tempUser.birthday = ('0' + this.day).slice(-2) + '.' + ('0' + this.month).slice(-2) + '.' + this.year;
                        this.$modal.hide('first-login');
                        this.$modal.show('first-login-2', { 'localUser': this.localUser });
                    }
                });
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/components/_validation';
</style>

<style lang="scss">
@import '~@/assets/styles/layout/_first-login';

.error-modal {
    transition: box-shadow 1s;

    &.has-bugs {
        box-shadow: 0 24px 80px -2px rgba(255, 0, 0, .4) !important;
    }
}
</style>
